<div class="govuk-width-container">
  <div class="govuk-grid-row">
    <div class="govuk-grid-column-two-thirds">
      <div class="app-prose-scope">
        <h1 id="privacy-policy">Accessibility Statement</h1>

        <p>
          This accessibility statement applies to the AdviceAid website - <a [routerLink]="meta.url">{{meta.url}}</a>
        </p>

        <p>This website is run by Neatlines Ltd. AdviceAid is committed to ensuring that the service is accessible to everyone regardless of disability, capability or technology.</p>

        <p>Some of the measures we have taken to ensure the service is accessible include:</p>

        <ul>
          <li>The webpages use relative font sizes allowing users to magnify the text up to 200% in the browser</li>
          <li>We use alternative text for all images.</li>
          <li>All web pages use valid XHTML.</li>
          <li>We conduct regular validation checks to ensure the HTML code is valid.</li>
          <li>We run regular checks of our pages against accessibility testing tools and audit against the WCAG guidelines.</li>
          <li>We made the website text as simple as possible to understand.</li>
        </ul>

        <!--- Get Help --->
        <h2>Get help</h2>
        <p><a href="https://abilitynet.org.uk/">AbilityNet</a> has advice on making your device easier to use if you have a disability:</p>
        <ul>
          <li><a href="https://mcmw.abilitynet.org.uk/impairment/making-your-mouse-easier-use">make your mouse easier to use</a></li>
          <li><a href="https://mcmw.abilitynet.org.uk/category/keyboard-shortcuts">use your keyboard instead of a mouse</a></li>
          <li><a href="https://mcmw.abilitynet.org.uk/impairment/talking-your-device">talk to your device</a></li>
          <li><a href="https://mcmw.abilitynet.org.uk/impairment/making-your-device-talk-you">make your device talk to you</a></li>
          <li><a href="https://mcmw.abilitynet.org.uk/impairment/making-text-larger">make text larger</a></li>
          <li><a href="https://mcmw.abilitynet.org.uk/impairment/changing-your-colours">change your colours</a></li>
          <li><a href="https://mcmw.abilitynet.org.uk/impairment/magnifying-screen">magnify the screen</a></li>
        </ul>

        <!--- Feedback --->
        <h2>Feedback and contact information</h2>
        <p><a routerLink="/contact">Contact us</a> if you need information on this website in a different format like accessible PDF, large print, easy read, audio recording or braille.</p>

        <h3>Reporting accessibility problems with this website</h3>
        <p>If you find any problems not listed on this page or think we’re not meeting accessibility requirements, please contact: <a href="support@adviceaid.uk">support@adviceaid.uk</a></p>

        <h3>Enforcement procedure</h3>
        <p>The Equality and Human Rights Commission (EHRC) is responsible for enforcing the Public Sector Bodies (Websites and Mobile Applications) (No. 2) Accessibility Regulations 2018 (the ‘accessibility regulations’).
          If you’re not happy with how we respond to your complaint, you can contact the Equality Advisory and Support Service (EASS).
        </p>

        <!--- Compliance status --->
        <h2>Technical information</h2>
        <h3>Compliance status</h3>
        <p>The HTML content of the website is compliant with the Web Content Accessibility Guidelines (WCAG) version 2.2 AA standard</p>
        <p>PDF documents generated by the service are not fully compliant. We recommend using the HTML version of the Advice content where possible.</p>

        <h3>What we are doing to improve accessibility</h3>
        <p *ngIf="meta.treeType === TreeType.Public; else notPublic">We are working closely with {{meta.teamName}} and other stakeholders to ensure the AdviceAid service is accessible to as many people as possible.</p>

        <ng-template #notPublic>
        <p>We are working closely with users and other stakeholders to ensure the AdviceAid service is accessible to as many people as possible.</p>
        </ng-template>

        <p>We ensure that whenever we update the website, we conform to WCAG accessibility standards.</p>

        <h3>Preparation of this accessibility statement</h3>
        <p>This statement was prepared on 25/01/2022. It was last reviewed on 14/08/2023. This website was last tested on 14/08/2023. The test was carried out by Neatlines Ltd.</p>
      </div>
  </div>

</div>
